import React from 'react';

import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';

import CheckboxedSection from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/CheckboxedSection';
import { updateOptions as incidentUpdateEventOptions } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IncidentEventSelect';
import PagerDutyConditionSelector from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/PagerDutyConditionSelector';
import RowLayout3Components from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RowLayout3Components';
import SelectActions from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions';
import { useApplicableActions } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions/actions';
import AutoscalableInputsArray from 'src/views/components/Form/AutoscalableInputsArray';
import FieldLabel from 'src/views/components/Form/FieldLabel';

const InfoMessage = () => {
  return ('');
};

const SingleConfigItem = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  const actions = useApplicableActions({ issueUpdateActions: true });

  return (
    <RowLayout3Components>
      <PagerDutyConditionSelector
        name={`${name}.condition`}
        values={values.condition}
        touched={touched.condition}
        errors={errors.condition}
        onChange={onChange}
        onBlur={onBlur}
        incidentEventOptions={incidentUpdateEventOptions}
      />
      <ArrowRightIcon size="xlarge"/>
      <SelectActions
        actions={actions}
        name={name}
        values={values}
        touched={touched}
        errors={errors}
        onChange={onChange}
        onBlur={onBlur}
      />
    </RowLayout3Components>
  );
};

const newItemValue = {
  condition: {
    pd_events: [],
    pd_urgency: null,
    pd_priorities: [],
  },
  actions: null,
  actions_params: {}
};

const isItemEmpty = (value) => {
  const { condition, actions } = value || {};
  if (Array.isArray(actions) && actions.length > 0) return false;
  const { pd_events, pd_urgency, pd_priorities } = condition || {};
  if (Array.isArray(pd_events) && pd_events.length > 0) return false;
  if (Array.isArray(pd_priorities) && pd_priorities.length > 0) return false;
  return !pd_urgency;
};

const ReactOnIncidentStatusChange = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <div>
      <CheckboxedSection
        name={`${name}.react_on_incident_event`}
        value={values.react_on_incident_event}
        onChange={onChange}
        onBlur={onBlur}
        label="Automatically update Jira issue"
        helpMessage={<InfoMessage/>}
      >

        <RowLayout3Components>
          <FieldLabel>When PagerDuty incident has linked issue AND:</FieldLabel>
          <div/>
          <FieldLabel>Actions:</FieldLabel>
        </RowLayout3Components>

        <AutoscalableInputsArray
          name={`${name}.react_on_incident_event_config`}
          values={values.react_on_incident_event_config}
          touched={touched.react_on_incident_event_config}
          errors={errors.react_on_incident_event_config}
          onChange={onChange}
          onBlur={onBlur}
          ItemComponent={SingleConfigItem}
          isItemEmpty={isItemEmpty}
          newItemValue={newItemValue}
        />
      </CheckboxedSection>
    </div>
  );
};

export default ReactOnIncidentStatusChange;
